import React, { useState } from 'react';

interface TabProps {
  tabsData: { label: string; content: React.ReactNode }[];
}

const Tab: React.FC<TabProps> = ({ tabsData }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <div className='rounded-sm shadow-xxl bg-white p-4 tracking-normal'>
      <div className='flex space-x-[94px] w-full border border-[#CDD0D7] px-2'>
        {tabsData.map((tab, idx) => (
          <button
            key={idx}
            className={`py-2 transition-colors duration-300 text-base ${
              idx === activeTabIndex
                ? 'text-black500 font-semibold underline'
                : 'border-transparent hover:border-gray-200'
            }`}
            onClick={() => setActiveTabIndex(idx)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className='py-4'>
        <span>{tabsData[activeTabIndex].content}</span>
      </div>
    </div>
  );
};

export default Tab;
